import { render, staticRenderFns } from "./personalInfoModal.vue?vue&type=template&id=3da2287c&scoped=true&"
import script from "./personalInfoModal.vue?vue&type=script&lang=js&"
export * from "./personalInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./personalInfoModal.vue?vue&type=style&index=0&id=3da2287c&scoped=true&lang=css&"
import style1 from "./personalInfoModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2287c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da2287c')) {
      api.createRecord('3da2287c', component.options)
    } else {
      api.reload('3da2287c', component.options)
    }
    module.hot.accept("./personalInfoModal.vue?vue&type=template&id=3da2287c&scoped=true&", function () {
      api.rerender('3da2287c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/profile/modals/personalInfoModal.vue"
export default component.exports